<div class="tutorization--block__column">
  <div class="tutorization--block__row">
    <lms-widget-container
      class="tutorization--block__item"
      [widget]="questionsRightAnswersWidget"
    ></lms-widget-container>
    <lms-widget-container
      class="tutorization--block__item"
      [widget]="questionsRatioAnswersWidget"
    ></lms-widget-container>
    <lms-widget-container class="tutorization--block__item" [widget]="questionsCreatedWidget"></lms-widget-container>
  </div>

  <div id="group-questions">
    <lms-group-questions-list
      #groupQuestions
      [listId]="listId"
      [options]="listOptions"
      (listUpdated)="setCollection($event)"
    ></lms-group-questions-list>
  </div>
</div>
